import '../../../../Assets/style/vendors/magnific-popup.less';
import translation from '../../common/others/translation';
import { isMobile } from '../../common/others/Configuration';

class MagnificPopup {
  constructor(element, options = {}) {
    this._element = element;
    this._options = options;

    // Convert jQuery array to native array
    if (this._element instanceof jQuery) {
      this._element = this._element.toArray();
    }

    // If not an array, that must be a single node (document.querySelector)
    // So, convert to array
    // Condition must pass both `Array` and `NodeList`
    if (this._element && typeof this._element.length === 'undefined') {
      this._element = [this._element];
    }

    if (!this._options.noBind) {
      this._bind();
    }
  }

  _bind() {
    if (!this._element) {
      return;
    }

    for (const element of this._element) {
      element.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          this.open(this._options);
        },
        false
      );
    }
  }

  get instance() {
    // If you have an error, that means you use instance property before the lib is loaded (async)
    // You can only after options.callbacks.open() has been called
    return ($.magnificPopup && $.magnificPopup.instance) || null;
  }

  async open(options) {
    await import(/* webpackChunkName: 'magnific-popup' */ 'magnific-popup');
    const closeTitle = translation('assets.javascript.magnificpopup.close');

    // https://dimsemenov.com/plugins/magnific-popup/documentation.html#translating
    // https://dimsemenov.com/plugins/magnific-popup/documentation.html#closemarkup
    $.extend(true, $.magnificPopup.defaults, {
      tClose: closeTitle, // Alt text on close button
      tLoading: translation('assets.javascript.magnificpopup.loading'), // Text displayed during loading
      closeMarkup: `<button title="${closeTitle}" type="button" class="mfp-close" aria-label="${closeTitle}">&times;</button>`,
      ajax: {
        tError: translation('assets.javascript.magnificpopup.error'), // Text when ajax request failed
      },
      removalDelay: isMobile ? '300' : '0', // Delay before popin is removed from DOM. Used for the animation
    });

    if (this._element) {
      $(this._element).magnificPopup(options);
      $(this._element).magnificPopup('open');
      return;
    }

    $.magnificPopup.open(options);
  }

  close() {
    const instance = this.instance;

    if (instance) {
      instance.close();
    }
  }
}

export { MagnificPopup };
